/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { Api } from '../../axios-config';
import { v4 as uuidv4 } from 'uuid';

export interface IListagemEmp {
    idempr: string;
    idfun: string;
    valor: number;
    periodo: string;
    nome: string;
    cpf: string;
    parcela: string;
    urlimg: string;
    status: boolean;
    motivo: string;
}

export interface IDetalheEmp {
  idfun: string;
  nome: string;
  valor: number;
  historico: string;
  vencimento: Date;
  periodo: string;
  parcela: string;
  idoperacao: string;  
  vtotal: number;
  urlimg: string;
  status: boolean;
}

export interface IDetalheEmpCreate {
  idfun: string;
  valor: number;
  historico: string;
  periodo: string;
  parcela: string;
  datalan: Date;
}

export interface IDetalheEmpUpdate {
  idfun: string;
  valor: number;
  historico: string;
  datalan: Date;
  periodo: string;
  parcela: string;
}

export interface IBaixaEmp {
  motivo: string;
  datapgto: Date;
}

export interface IFormDataParcelasEmpFun {
  idempr: string;
  idfun: string;
  valor: number;
  historico: string;
  datalan: Date;
  periodo: string;
  parcela: string;
  idoperacao: string;
  vtotal: number;
}

interface IRempFun{
  nome: string;
  cpf: string;
  periodo: string;
  valor: number;
  status: boolean;
  motivo: string;
}

interface IRecebido{
  recebido: number
}

interface IReceber{
  receber: number
}


export interface IRelatorioFun {
  emprestimo: IRempFun[],
  recebidos: IRecebido,
  receber: IReceber,
}

type TotalCount = {
    data: IListagemEmp[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/empfun?page=${page}&limit=${Environment.LIMITE_DE_LINHASSMALL}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);  
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHASSMALL),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<IDetalheEmp | Error> => {
  try {
    const { data } = await Api.get(`/empfun/${id}`);
   
    if (data) {
      return data;
    }
 
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IDetalheEmpCreate): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const total = dados.valor;
    const { data } = await Api.post<IDetalheEmp>('/empfun',  [{idempr: guuid, idoperacao: guuid, vtotal: total, ...dados}]); 
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const createparcelas = async (dados: IFormDataParcelasEmpFun[]): Promise<string | Error> => {
  try {

    const guuid = dados[0].idempr;

    const { data } = await Api.post<IFormDataParcelasEmpFun>('/empfun',  dados);
  
    if (Object.keys(data).length === 0) {
      return guuid;
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IDetalheEmpUpdate): Promise<void | Error> => {
  try {     
    await Api.put(`/empfun/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Baixa = async (id: string, dados: IBaixaEmp): Promise<void | Error> => {
  try {     
    await Api.put(`/empfunbaixa/${id}`, {status: true, ...dados});
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/empfun/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Relatorio = async (periodo = ''): Promise<IRelatorioFun | Error> => {
  try {
    const urlRelativa = `/rempfun?periodo=${periodo}`;
  
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const EmpFunService = {
  getAll,
  create,
  createparcelas,
  getById,
  updateById,
  deleteById,
  Baixa,
  Relatorio,
};